import { checkAccess } from "~/utils/constants";

const state = () => ({
  userEmail: "",
  isAdmin: false,
  isAuthorize: false,
  isGuest: false,
  access_token: null,
  refresh_token: null,
  expires_in_token: null,
  expires_in_refresh_token: null,
  signed_data: null,
  authUser: {},
  resetPassword: false,
  resetPasswordToken: null,
  resetPasswordUser: null,
  subscriptions: null,
  impersonation: null,
});

const getters = {
  isAuthorize: (state) => state.isAuthorize,
  isGuest: (state) => state.isGuest,
  subscriptions: (state) => state.subscriptions,
  workspaceAccess: (state) =>
    checkAccess(state.subscriptions.legacy_permissions, "workspace") ||
    checkAccess(state.subscriptions.permissions, "workspace"),
};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  setApiToken: (state, data) => {
    state.apiToken = data;
  },
  setToken: (state, data) => {
    state.tokenData = data;
    state.access_token = data.access_token;
    state.expires_in_token = data.expires_in;
    state.expires_in_refresh_token = data.expires_in;
    if (data.refresh_token) {
      state.refresh_token = data.refresh_token;
    }
  },
  setSubscriptions: (state, data) => {
    state.subscriptions = data;
  },
  setImpersonation: (state, data) => {
    state.impersonation = data;
  },
};

const actions = {
  getToken({ commit }) {
    return this.$axios({
      method: "GET",
      url: `${this.$config.clientURL}/api/getToken`,
      progress: false,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  },

  token({ commit }, { username, password }) {
    return this.$axios({
      method: "POST",
      url: `${this.$config.clientURL}/api/getToken`,
      headers: { "Content-Type": "application/json" },
      progress: true,
      data: {
        grant_type: "password",
        username,
        password,
      },
    })
      .then((data) => data.data)
      .catch((error) => error);
  },

  logout() {
    return this.$axios({
      method: "POST",
      url: `${this.$config.clientURL}/api/logout`,
      headers: { "Content-Type": "application/json" },
      progress: true,
    })
      .then((data) => data.data)
      .catch((error) => error);
  },

  async apiToken({ commit }, { email, password }) {
    const data = {
      email,
      password,
    };
    const body = {
      method: "POST",
      url: `${this.$config.vixioAuthURL}/authentication_token`,
      headers: {
        "Content-Type": "application/json",
      },
      progress: false,
      data,
    };

    return await this.$axios(body)
      .then((data) => data.data)
      .catch(({ response }) => {
        // console.log(response);
      });
  },
  refreshToken({ commit }, body) {
    return this.$axios({
      method: "post",
      url: `${this.$config.clientURL}/api/getToken`,
      headers: { "Content-Type": "application/json" },
      progress: false,
      data: body,
    })
      .then(({ data }) => {
        // api/getToken wraps Drupal's response in { data: <body string>, statusCode }.
        // We must parse the inner body and verify it actually contains tokens —
        // previously we blindly committed the error body, which set state.access_token
        // to undefined and broke every subsequent authenticated call until re-login.
        let inner = data && data.data;
        inner = typeof inner === "string" ? JSON.parse(inner) : inner;
        if (!inner || !inner.access_token || !inner.refresh_token) {
          // eslint-disable-next-line no-console
          console.error("[auth] Auth/refreshToken failed", inner || data);
          throw new Error("refresh_failed");
        }
        commit("setToken", inner);
        return inner;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
